import { useParamsSearch } from '@anytag/shared-hooks';
import { PostsFilterSearchSchemaType } from '../schemaTypes';

export const usePostsFilter = () => useParamsSearch<PostsFilterSearchSchemaType>();
